var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;

var exports = {};

function getSelectionRaw() {
  return _global.getSelection();
}

exports = getSelectionRaw;
export default exports;